import { render, staticRenderFns } from "./Token.vue?vue&type=template&id=33918168&scoped=true&"
import script from "./Token.vue?vue&type=script&lang=js&"
export * from "./Token.vue?vue&type=script&lang=js&"
import style0 from "./Token.vue?vue&type=style&index=0&id=33918168&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33918168",
  null
  
)

export default component.exports